import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapDesktopComponent } from './components/map/map-desktop/map-desktop.component';
import { FooterComponent } from './components/map/footer/footer.component';
import { DesktopAppComponent } from './components/desktop-app/desktop-app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { MyAccountComponent } from './components/authentication/my-account/my-account.component';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DividerModule } from 'primeng/divider';
import { AboutComponent } from './components/legends/about/about.component';
import { LayersComponent } from './components/legends/layers/layers.component';
import { LegendComponent } from './components/legends/legend/legend.component';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { SearchComponent } from './components/search/search.component';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { SidebarModule } from 'primeng/sidebar';
import { ModelHeadbandComponent } from './components/model-headband/model-headband.component';
import { DepthModalComponent } from './components/model-headband/depth-modal/depth-modal.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ModeleModalComponent } from './components/model-headband/modele-modal/modele-modal.component';
import { MapSensorsComponent } from './components/model-headband/modele-modal/map-sensors/map-sensors.component';
import { ModeleModalGraphForecastComponent } from './components/model-headband/modele-modal/modele-modal-graph-forecast/modele-modal-graph-forecast.component';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { ModeleModalGraphRealtimeComponent } from './components/model-headband/modele-modal/modele-modal-graph-realtime/modele-modal-graph-realtime.component';
import { FloatLabelModule } from 'primeng/floatlabel';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { PrefPositionComponent } from './components/map/pref-position/pref-position.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TimelineModule } from 'primeng/timeline';
import { CalendarModule } from 'primeng/calendar';
import { ScenarioComponent } from './components/map/footer/scenario/scenario.component';
import { ChartComponent } from './components/model-headband/chart/chart.component';
import { DepthDetailComponent } from './components/model-headband/depth-detail/depth-detail.component';
import { TagModule } from 'primeng/tag';
import { SourceChartComponent } from './components/model-headband/source-chart/source-chart.component';
import { ChartTooltipComponent } from './components/model-headband/chart-tooltip/chart-tooltip.component';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initializeApp(translate: TranslateService) {
  return () => {
    return new Promise<void>((resolve) => {
      translate.setDefaultLang('fr');  // Définit la langue par défaut
      translate.use('fr').subscribe(() => {
        resolve();
      }, (error) => {
        console.error('Erreur lors du chargement des traductions :', error);
        resolve();  // Résoudre même en cas d'erreur pour ne pas bloquer l'application
      });
    });
  };
}

@NgModule({
  declarations: [
    MapDesktopComponent,
    FooterComponent,
    DesktopAppComponent,
    MyAccountComponent,
    AboutComponent,
    LayersComponent,
    LegendComponent,
    SearchComponent,
    ModelHeadbandComponent,
    DepthModalComponent,
    ModeleModalComponent,
    MapSensorsComponent,
    ModeleModalGraphForecastComponent,
    ModeleModalGraphRealtimeComponent,
    PrefPositionComponent,
    ChartComponent,
    DepthDetailComponent,
    ScenarioComponent,
    SourceChartComponent,
    ChartTooltipComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ButtonModule,
    OverlayPanelModule,
    DividerModule,
    DialogModule,
    CheckboxModule,
    FormsModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    RadioButtonModule,
    DropdownModule,
    TimelineModule,
    SidebarModule,
    FontAwesomeModule,
    ProgressSpinnerModule,
    TooltipModule,
    DropdownModule,
    FloatLabelModule,
    AutoCompleteModule,
    InputGroupModule,
    InputGroupAddonModule,
    CalendarModule,
    TagModule,
    ButtonModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [TranslateService],
      multi: true
    }
  ]
})
export class CoreDesktopModule { }
